<template>
  <b-overlay :show="loading">

  <div class=" employee-tab leave-attendance-dashboard">

    <div class="col-md-10 col-sm-12 pl-0 mb-5" >
      <h4 class="atlhr-dashboard-title mt-10">Leave & Attendance<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Leave & Attendance / Swap Request</span></h4>
    </div>


    <b-tabs pills v-model="rosterTabIndex" content-class="custom-tab-content" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white" nav-class="mb-4 mt-3 leave-attendance-dashboard-tab">


      <b-tab lazy title="Pending Approval" v-if="$acl['roster/data'] == 2">
        <div class="">

          <div class="d-flex justify-content-end">
            <b-button @click="$bvModal.show('bv-modal-swap-request-create')">Create Swap Request</b-button>
          </div>
          
          
          <roster-swap-requests-pending :key="componentKey" @childToParent="loadData" :swaps="swaps[0]" :status="0"></roster-swap-requests-pending>
        </div>
      </b-tab>
          <b-tab lazy title="Approved" v-if="$acl['roster/data'] == 2">
        <div class="">
          <roster-swap-requests-approved :key="componentKey+1" @childToParent="loadData" :swaps="swaps[1]" :status="1"></roster-swap-requests-approved>
        </div>
      </b-tab>
          <b-tab lazy title="Declined" v-if="$acl['roster/data'] == 2">
        <div class="">
          <roster-swap-requests-declined :key="componentKey+2" @childToParent="loadData" :swaps="swaps[2]" :status="2"></roster-swap-requests-declined>
        </div>
      </b-tab>

        </b-tabs>
      

      <b-modal id="bv-modal-swap-request-create" title="Add Swap Request" hide-footer @hidden="resetForm" size="xl" scrollable>
        <h5 v-if="fdata.from_employee_id == null">Select an employee to create a swap request.</h5>
        <div class="mt-5" v-if="fdata.from_employee_id == null">
          <roster-search-employees :all="0" :flg="1" v-on:childToParent="setEmployeeSwap"></roster-search-employees>
        </div>

        <b-card v-else>
          <b-form>
            <b-row>
              <b-col cols="12" md="12">
                <b-form-group label-for="from-emp">
                  <template #label>
                    From Employee (Requesting Swap) <b-icon icon="info-circle" variant="info" v-b-tooltip.hover.top="'Employee who wants to swap their assigned shift.'"></b-icon>
                  </template>
                  <b-form-select id="from-emp" name="from_employee_id" v-model="fdata.from_employee_id" :options="fromEmployeeOptions" disabled>
                  </b-form-select>

                  <small v-if="fromAssignment.shift" class="text-muted d-block mt-1">
                    Current: {{ fromAssignment.shift.name }}
                    ({{ fromAssignment.shift.start_time }}–{{ fromAssignment.shift.end_time }})
                  </small>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group id="start-group" label-for="start" class="required-field mb-0">
                  <template #label>
                    Start Date <b-icon icon="info-circle" variant="info" v-b-tooltip.hover.top="'Pick the start date to load all shifts the employee has from this date onward.'"></b-icon>
                  </template>
                  <b-input-group class="mb-0">
                    <b-form-input @input="setToDateAndLoadShift" id="start" name="start" v-model="fdata.start" v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                                  autocomplete="off" :state="validateState('start')" aria-describedby="start-feedback" data-vv-as="Start Date"/>
                    <b-input-group-append class="mb-0">
                      <b-form-datepicker @input="setToDateAndLoadShift" class="mb-0" id="day_one" button-only right locale="en-US" v-model="fdata.start" />
                    </b-input-group-append>
                    <b-form-invalid-feedback id="start-feedback">
                      {{ veeErrors.first('start') }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group id="end-group" label-for="end" class="required-field">
                  <template #label>
                    End Date <b-icon icon="info-circle" variant="info" v-b-tooltip.hover.top="'Pick the end date to load all shifts the employee has up to this date.'"></b-icon>
                  </template>
                  <b-input-group class="mb-0">
                    <b-form-input id="end" name="end" @input="loadEmployeeShifts" v-model="fdata.end" v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                                  autocomplete="off" :state="validateState('end')" aria-describedby="end-feedback" data-vv-as="End Date"/>
                    <b-input-group-append class="mb-0">
                      <b-form-datepicker :min="fdata.start" @input="loadEmployeeShifts" class="mb-0" id="day_two" button-only right locale="en-US" v-model="fdata.end" />
                    </b-input-group-append>
                    <b-form-invalid-feedback id="end-feedback">{{ veeErrors.first('end') }}</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>


              <b-col cols="12" md="12">
                <b-form-group label="Select Shift" label-for="shift_id" class="required-field">
                  <b-form-select id="shift_id" name="shift_id" v-model="fdata.shift_id" :options="employeeShifts" v-validate="{required: true}"
                                 :state="validateState('shift_id')" aria-describedby="shift_id-feedback" data-vv-as="Shift"/>
                  <b-form-invalid-feedback id="shift_id-feedback">{{ veeErrors.first('shift_id') }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group id="target_date-group" label-for="target_date" class="required-field mb-0">
                  <template #label>
                    Swap Desired Date <b-icon icon="info-circle" variant="info" v-b-tooltip.hover.top="'The date the employee wants to exchange their shift for.'"></b-icon>
                  </template>
                  <b-input-group class="mb-0">
                    <b-form-input @input="fdata.end = fdata.target_date;" id="target_date" name="target_date" v-model="fdata.target_date"
                                  v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                  :state="validateState('target_date')" aria-describedby="target_date-feedback" data-vv-as="Period Start Date"/>
                    <b-input-group-append class="mb-0">
                      <b-form-datepicker class="mb-0" id="day_one" :min="minDate" button-only right locale="en-US" v-model="fdata.target_date" />
                    </b-input-group-append>
                    <b-form-invalid-feedback id="target_date-feedback">{{ veeErrors.first('target_date') }}</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="6" md="6">
                <b-form-group label-for="to-shift" class="required-field">
                  <template #label>
                    Desired Shift <b-icon icon="info-circle" variant="info" v-b-tooltip.hover.top="'Select the shift the employee wants to work on the selected date.'"></b-icon>
                  </template>
                  <b-form-select id="to-shift" name="to_shift_id" v-model="fdata.target_shift" :options="shiftOptions" @change="loadTo()"
                                 v-validate="'required'" :state="validateState('to_shift_id')" aria-describedby="to_shift_id-feedback" data-vv-as="To Shift">
                    <template #first>
                      <b-form-select-option :value="null" disabled>Select Shift</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="to_shift_id-feedback">{{ veeErrors.first('to_shift_id') || ' ' }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="12">
                <b-form-group label-for="to-emp" class="required-field">
                  <template #label>
                    Swap With Employee <b-icon icon="info-circle" variant="info" v-b-tooltip.hover.top="'Choose the employee who will exchange shifts on the desired date.'"></b-icon>
                  </template>
                  <b-form-select id="to-emp" name="to_employee_id" v-model="fdata.to_employee_id" :options="toEmployeeOptions" v-validate="'required'"
                                 :state="validateState('to_employee_id')" aria-describedby="to_employee_id-feedback" data-vv-as="Employee">
                    <template #first>
                      <b-form-select-option :value="null" disabled>Select employee</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="to_employee_id-feedback">{{ veeErrors.first('to_employee_id') }}</b-form-invalid-feedback>

                  <small v-if="toAssignment.shift" class="text-muted d-block mt-1">
                    Current: {{ toAssignment.shift.name }}
                    ({{ toAssignment.shift.start_time }}–{{ toAssignment.shift.end_time }})
                  </small>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group label="Reason (optional)" label-for="reason">
              <b-form-textarea id="reason" name="reason" v-model="fdata.reason" v-validate="'max:255'" :state="validateState('reason')" aria-describedby="reason-feedback" maxlength="255" placeholder="Short reason"/>
              <b-form-invalid-feedback id="reason-feedback">{{ veeErrors.first('reason') }}</b-form-invalid-feedback>
            </b-form-group>

            <b-button type="button" @click="submit" variant="primary">Submit Swap Request</b-button>
            <b-button @click="resetForm" type="button">Reset</b-button>
            <b-button variant="primary" @click="backSwap" type="button">Back</b-button>
          </b-form>
        </b-card>
      </b-modal>


    </div>
  </b-overlay>
</template>

<script>

import moment from "moment";

export default {
  data () {
    return {
      swaps: [[],[],[]],
      page: 1,
      componentKey: 1,
      perPage: 10,
      totalRows: 0,
      totalPages: null,
      loading: false,
      selectedShift: null,
      fields: [
        { key: 'index', label: '#', thStyle: { width: '80px' } },
        { key: 'from_employee_name', label: 'From' },
        { key: 'from_shift_name', label: 'From Shift' },
        { key: 'from_date', label: 'From Shift Date' },
        { key: 'to_employee_name', label: 'To' },
        { key: 'to_shift_name', label: 'To Shift' },
        { key: 'to_date', label: 'To Shift Date' },
        { key: 'created', label: 'Date' },
        { key: 'status', label: 'Status', class: 'text-center', thStyle: { width: '120px' } },
        { key: 'actions', label: '', class: 'text-right', thStyle: { width: '160px' } },
      ],

      fromEmployeeOptions:[],
      toEmployeeOptions:[],

      employees: [],
      shifts: [],
      shiftOptions: [],
      employeeShifts:[],
      fdata: {
        date: '',
        shift_id: null,
        from_employee_id: null,
        to_employee_id: null,
        reason: '',
        start: '',
        end: '',
        target_date: '',
        target_shift: null,
      },
      employee_id: 0,
      fromAssignment: {},
      toAssignment: {},

      pagination: {currentPage: 1, pages:1},
      length_options:
          [
            { value: 20, text: "20" },
            { value: 50, text: "50" },
            { value: 100, text: "100" },
            { value: 500, text: "500" },
            { value: 1500, text: "1500" },
          ],
      temp_length: 100,
    }
  },
  computed:{
    minDate(){
      const d = new Date();
      d.setDate(d.getDate() + 1);
      return d.toISOString().split("T")[0];
    },
  },
  methods: {
    loadData () {
      this.loading = true;
      axios.get('/leave-attendance/swaps').then(response => {
        this.swaps = response.data;
        this.componentKey++;
        this.loading = false;
      }).catch(e=>{
        this.serverError(e);
        this.loading = false;
      });
    },
    validateState(ref)
    {
      if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    backSwap(){
      this.fdata.from_employee_id = null;
      },
    setEmployeeSwap: function(x)
    {
      this.fdata.from_employee_id = x.employee_id;
      this.loadEmployeeShifts();
    },
    resetForm(){
      this.fdata = {
        date: '',
        to_shift_id: null,
        from_employee_id: null,
        to_employee_id: null,
        reason: '',
        start: '',
        end: '',
        target_date: '',
        target_shift: null,
      };
    },
    setToDateAndLoadShift(){
      this.fdata.end = this.fdata.start;
      this.loadEmployeeShifts();
    },
    loadEmployeeShifts(){
      let params = {employee_id: this.fdata.from_employee_id};

      const ymdPattern = /^\d{4}-\d{2}-\d{2}$/;
      let start = new Date(this.fdata.start);
      if (!ymdPattern.test(this.fdata.start) || isNaN(start.getTime())) {
        return;
      }
      params['start'] = this.fdata.start;

      let end = new Date(this.fdata.end);
      if (!ymdPattern.test(this.fdata.end) || isNaN(end.getTime())) {
        return;
      }
      params['end'] = this.fdata.end;

      axios.get(this.$api_url + '/leave-attendance/employee/assignments', {
        params: params,
      }).then(response => {
        this.employeeShifts = response.data;
        // if(this.employeeShifts.length > 0){
        //   this.fdata.shift_id = this.employeeShifts[0];
        // }
      })
    },
    loadEmployees(){
      axios.get(this.$api_url + '/leave-attendance/employees/list',{
        params:{
          fields:'offday,roster,shift'
        }
      }).then(response => {
        this.fromEmployeeOptions = response.data.employee_data;
      }).catch(e => {
        this.serverError(e);
      });
    },
    loadShifts(){
      axios.get('/leave-attendance/shifts').then(response => {
        this.shifts = response.data;
        this.shiftOptions = this.shifts.map(el => ({
          text: `${el.name} -- (${moment(el.start_time, 'HH:mm:ss').format('hh:mm A')} - ${moment(el.end_time, 'HH:mm:ss').format('hh:mm A')})`,
          value: el.value,
        }));
      });
    },
    loadTo(){
      let formData = new FormData();
      formData.append('employee_id', this.fdata.from_employee_id);
      formData.append('target_date', this.fdata.target_date);
      formData.append('target_shift', this.fdata.target_shift);

      axios.post('/leave-attendance/employees/range', formData).then(response => {
        this.toEmployeeOptions = response.data.filter(({value}) => this.fdata.from_employee_id != value);
      }).catch(error => {
        this.serverError(error);
      })
    },
    submit(){
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }
        const payload = {
          assignment_id: this.fdata.shift_id,
          to_date: this.fdata.target_date,
          from_employee_id: this.fdata.from_employee_id,
          to_employee_id: this.fdata.to_employee_id,
          to_shift_id: this.fdata.target_shift,
          reason: this.fdata.reason,
        }
        axios.post('/leave-attendance/swaps/create', payload, {
          headers: {'Content-Type': 'application/json'}
        }).then(response => {
          this.loadData();
          this.$bvToast.toast('Swap created.', {variant: 'success', solid: true, title: 'Success'});
          this.$bvModal.hide('bv-modal-swap-request-create');
        }).catch(e => {
          this.serverError(e);
        });
      });
    },
  },
  mounted () {
    this.loadShifts();
    this.loadEmployees();
    this.loadData();
  },
}
</script>